import { inject } from '@angular/core';
/**
 * Guard por **rol**: permite la navegación solo si el usuario tiene rol administrador.
 *
 * Usa {@link AuthService.checkRolePermission} con {@link UserRole.admin}. Si el rol no coincide,
 * redirige según la lógica de {@link AuthService.redirectBasedOnUSerRole}.
 *
 * @see AuthService
 */

import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { UserRole } from '../models/auth.model';

export const isAdminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);

  return await authService.checkRolePermission(UserRole.admin);
};
